import { DatePicker, Input, Select } from "antd";
import moment from "moment";
import React, { useState } from "react";
import remove from "../../assets/icons/remove.png";
import InputSelect from "./InputSelect";

const keys = {
  advance_id: "advance_ids",
  reference_numbers: "advance_ids",
  employee_id: "employee_ids",
  employee_name: "employee_names",
  report_id: "report_ids",
  report_name: "report_name",
  approval_status: "status",
};

const FilterInputs = ({
  filters,
  setFilterObj,
  filtersObj,
  ele,
  remove: rmFunc,
  customized_data,
  index
}) => {
  const [dateSelect, setDateSelect] = useState();
  const [isAll, setIsAll] = useState(false);

  const getComponent = (type, ele) => {
    switch (type) {
      case "date":
        return (
          <>
            <Select
              className="w25"
              options={[
                { label: "Date Range", value: "dr" },
                { label: "Is Before", value: "before" },
                { label: "Is After", value: "after" },
              ]}
              onChange={(e) => {
                setDateSelect(e);
              }}
            />
            {dateSelect === "dr" ? (
              <>
                <DatePicker
                  className="w25"
                  type={"date"}
                  onChange={(e) => {
                    setFilterObj((fils) => ({
                      ...fils,
                      start_date: moment(e).format("DD/MM/YYYY"),
                    }));
                  }}
                />
                <DatePicker
                  className="w25"
                  type={"date"}
                  disabledDate={(d) => {
                    return (
                      d &&
                      new Date(d.format("YYYY-MM-DD")).getTime() <
                      new Date(
                        moment(filtersObj?.start_date, "DD/MM/YYYY").format(
                          "YYYY-MM-DD"
                        )
                      ).getTime()
                    );
                  }}
                  onChange={(e) => {
                    setFilterObj((fils) => ({
                      ...fils,
                      end_date: moment(e).format("DD/MM/YYYY"),
                    }));
                  }}
                />
              </>
            ) : (
              <DatePicker
                className="w50"
                type={"date"}
                onChange={(e) => {
                  setFilterObj((fils) => ({
                    ...fils,
                    [dateSelect === "before" ? "before_date" : "after_date"]:
                      moment(e).format("DD/MM/YYYY"),
                  }));
                }}
              />
            )}
            <img
              className="ml1 cursor"
              src={remove}
              alt="remove"
              height={20}
              onClick={() => {
                let filtes = filters;
                delete filtes.before_date;
                delete filtes.after_date;
                delete filtes.end_date;
                delete filtes.start_date;
                setFilterObj(filtes);
                rmFunc(index);
              }}
            />
          </>
        );
      case "string":
        return (
          <>
            <InputSelect
              options={
                customized_data
                  ? customized_data[keys[ele] ? keys[ele] : ele]?.map(
                    (ele) => ({ label: ele, value: ele })
                  )
                  : []
              }
              isAll={isAll}
              setIsAll={setIsAll}
              isFilter={true}
              values={filtersObj[ele] ? filtersObj[ele] : []}
              onChange={(vals) => {
                setFilterObj((fils) => ({
                  ...fils,
                  [ele]: vals,
                }));
              }}
            />
            <img
              className="ml1 cursor"
              src={remove}
              alt="remove"
              onClick={() => {
                let filtes = { ...filters };
                delete filtes[ele];
                delete filtes.search;
                setFilterObj({ ...filtes });
                rmFunc(index);
              }}
            />
          </>
        );
      case "number":
        return (
          <>
            <Select
              className="w25"
              options={[
                { label: "Range", value: "range" },
                { label: "Is Lessthan", value: "before" },
                { label: "Is Greaterthan", value: "after" },
              ]}
              onChange={(e) => {
                setDateSelect(e);
              }}
            />
            {dateSelect === "range" ? (
              <>
                <Input
                  className="w25"
                  pattern="[0-9]*"
                  onChange={(e) => {
                    setFilterObj((fils) => ({
                      ...fils,
                      start_amount: e.target.value,
                    }));
                  }}
                  placeholder="Min Amount"
                />
                <Input
                  className="w25"
                  pattern="[0-9]*"
                  onChange={(e) => {
                    setFilterObj((fils) => ({
                      ...fils,
                      end_amount: e.target.value,
                    }));
                  }}
                  placeholder="Max Amount"
                />
              </>
            ) : (
              <Input
                className="w50"
                pattern="[0-9]*"
                onChange={(e) => {
                  setFilterObj((fils) => ({
                    ...fils,
                    [dateSelect === "before"
                      ? "lesser_amount"
                      : "greater_amount"]: e.target.value,
                  }));
                }}
              />
            )}
            <img
              className="ml1 cursor"
              src={remove}
              alt="remove"
              width={14}
              onClick={() => {
                let filtes = filters;
                delete filtes.lesser_amount;
                delete filtes.greater_amount;
                delete filtes.end_amount;
                delete filtes.start_amount;
                setFilterObj(filtes);
                rmFunc(index);
              }}
            />
          </>
        );
      case "select":
        return (
          <>
            <Select
              className="w75"
              options={customized_data[keys[ele] ? keys[ele] : ele]?.map(
                (ele) => ({
                  label:
                    ele.replace("_", " ").charAt(0).toUpperCase() +
                    ele.replace("_", " ").slice(1),
                  value: ele,
                })
              )}
              onChange={(e) => {
                setFilterObj((fils) => ({
                  ...fils,
                  [ele]: e,
                }));
              }}
              value={filtersObj[ele]}
            />
            <img
              className="ml1 cursor"
              src={remove}
              alt="remove"
              width={14}
              onClick={() => {
                let filtes = filters;
                delete filtes[ele];
                setFilterObj(filtes);
                rmFunc(index);
              }}
            />
          </>
        );

      default:
        return null;
    }
  };
  return <>{getComponent(filters[ele], ele)}</>;
};

export default FilterInputs;
